import gql from "graphql-tag";

export const GET_STUDENTS_NO_PAGINATION = gql`
  query GetPerson($origin: QueryOrigin!) {
    students(origin:$origin) {
      edges {
        node {
          id
          firstName
          lastName
          dob
        }
      }
    }
  }
`;
